import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új ellátóhely',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }],
        rowActions: [
            {
                btn_text: '<i class="fas fa-copy"></i>',
                title: 'Másolás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'copyRow',
                additionalButtonVisible:'deactivateCompanySiteVisible'
            }, {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow',
                additionalButtonVisible:'deactivateCompanySiteVisible'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
            },
            {
                btn_text: '<i class="fas fa-ban"></i>',
                title: 'Ellátóhely végleges deaktiválása',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deactivateRow',
                additionalButtonVisible:'deactivateCompanySiteVisible'
            }
        ],
        headerFields: [
            {
                name: "companyId",
                label: "Cég",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllCompany,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "siteName",
                label: "Ellátóhely neve",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "colour",
                label: "Ellátóhely színe",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'color',
                formSize: 4,
                formVisible: true,
                formRequired: true
            },
            {
                name: "siteManager",
                label: "Ellátóhely-vezető neve",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "siteManagerPhone",
                label: "Ellátóhely-vezető telefonszáma",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'tel',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "siteManagerEmail",
                label: "Ellátóhely-vezető e-mail címe",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "priceListId",
                label: "Árlista",
                visibility: false,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllPriceListsForSelect,
                    formatText: function (val) { 
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true,
                formRequired: true
            },
            {
                name: "active",
                label: "Ellátóhely státusza",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formType: 'text',
                formSize: 3,
                formVisible: false,
                slot_name: 'companySite_deactivation_format',  
            },
            {
                name: "googleRecaptchaKey",
                label: "Google Recaptcha kulcs",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
                formSize: 3,
                formVisible: true
            },
            {
                name: "logoUrl",
                label: "Logó URL",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
                formVisible: true,
                formSize: 3
            },
            {
                name: "centerCode",
                label: "Centerkód ",
                visibility: false,
                formVisible: true,
                formType: 'text',
                formSize: 3
            },
            {
                name: "sendToSynlabTime",
                label: "SYNLAB beküldés időpontja",
                visibility: true,
                formVisible: true,
                formType: 'hourWithSeconds',
                formSize: 3,
                slot_name: 'time_with_seconds_to_hour_formatter'
            },
            {
                name: "address",
                visibility: false,
                formType: 'address',
                formVisible: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
    }
}
